import React, { Fragment, useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Spinner 
} from 'reactstrap'
import { ArrowLeft, ArrowRight, CheckCircle } from 'react-feather'
import { Controller, useForm } from 'react-hook-form'
import CustomDate from '../../../../components/date-picker'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import Flatpickr from 'react-flatpickr'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import classnames from 'classnames'

// ** Third Party Components
import Cleave from 'cleave.js/react'

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss'
import styles from '../styles.module.scss'
import Select from 'react-select'
import { selectThemeColors } from '../../../../../utility/utils'
import { documentTypes } from '../../../../../utility/helpers'
import axios from 'axios'
import { yupResolver } from '@hookform/resolvers/yup'

import { schemaFields } from './validations'
import moment from "moment";
import { display } from '@mui/system'

const optionsDate = {
  locale: {
    ...Spanish,
    months: {
      ...Spanish.months,
      longhand: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]
    }
  },
  dateFormat: 'Y-m-d',
  defaultDate: 'today',
  maxDate: '2023-01-31',
  minDate: '1910-01-01',
  allowInput: true,
  monthSelectorType: 'dropdown'
}

const optionsDateBirthDay = {
  ...optionsDate,
  defaultDate: '2000-01-01',
  maxDate: '2012-01-31'
}
const PersonalInfo = ({
  stepper,
  userToRegister,
  setUserToRegister,
  token,
  setMobile,
  onFinish,
  docId
}) => {
  const defaultValues = userToRegister
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [verified, setVerified] = useState(false)
  const [isValidData, setIsValidData] = useState(false);
  const BASE_URL = `${process.env.REACT_APP_API_SERVICE_URL || 'https://firma.rubridoc.com'}/api`

  const {
    control,
    setError,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset
  } = useForm({
    mode: 'all',
    defaultValues,
    resolver: yupResolver(schemaFields)
  })
  const [isDuiValidation, setIsDuiValidation] = useState(false)
  const watchDocumentType = watch('documentType')

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        // Crear una instancia de axios sin interceptores
        const uninterceptedAxiosInstance = axios.create();
  
        // Realizar la llamada a la API
        const clientValidateResult = await uninterceptedAxiosInstance.get(
          `${BASE_URL}/client/info/${docId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );
        setValue("firstName", clientValidateResult.data.firstName)
        setValue("lastName", clientValidateResult.data.lastName)
        setValue("documentType", clientValidateResult.data.identificationType === "DUI" ? {label: "DUI", value: 1} : {label: "NIT", value: 8})
        setValue("documentNumber", clientValidateResult.data.identificationNumber)
        setValue("phoneNumber", clientValidateResult.data.phoneNumber)
  
        // Manejar los datos recibidos
        console.log("clientValidateResult: ", clientValidateResult.data);
      } catch (error) {
        // Manejo de errores
        console.error("Error fetching client data: ", error);
      }
    };
  
    // Llamar a la función async
    fetchClientData();
  },[docId])

  useEffect(() => {
    // console.log(errors)
  }, [errors])

 /*useEffect(() => {
    if (watchDocumentType.label === documentTypes[0].label) {
      setIsDuiValidation(true)
    } else {
      setIsDuiValidation(false)
    }
    setValue('documentNumber', '')
  }, [watchDocumentType])*/

  const TIME_AWAIT = 500

  const checkIsValid = (data) => {
    return Object.values(data).every((field) =>
      (typeof field === 'object' ? field !== null : field?.length > 0)
    )
  }

  const verifiedAction = () => {
    onFinish()
    stepper.next()
    setVerified(false)
  }

  const onSubmit = async (data) => {
    onFinish()
    stepper.next()
    setVerified(false)
  }
  return (
    <div className="col-lg-8 col-md-12 col-sm-12 py-4 m-auto">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={'px-3 py-3'}>
          <CardHeader>
            <h2 className="brand-text mb-0 text-primary">RubriDoc</h2>
            <span className="float-end">Información personal</span>
          </CardHeader>
          <CardBody className={'pb-0'}>
            {<p className={`${styles.textJustify} align-items-left mb-1`}>
              Por favor verificar si los siguientes datos son correctos, en caso no lo sean contactarse con su ejecutivo
            </p>}
            <hr />

            {loading && (
              <div className="row">
                <div className="col-12 px-2 py-4 text-center">
                  <Spinner size="lg" />
                  <CardText className={'py-1 fs-5'}>
                    Verificando información...
                  </CardText>
                </div>
              </div>
            )}

            {!loading && !verified && (
              <Fragment>
                <Row>
                  <Col md="4" className="mb-1">
                    <Label className="form-label" for="firstName">
                      Nombres
                    </Label>
                    <Controller
                      id="firstName"
                      name="firstName"
                      control={control}
                      render={({ field }) => (
                        <Input
                          placeholder="John"
                          invalid={errors.firstName && true}
                          readOnly
                          {...field}
                        />
                      )}
                    />
                    {errors.firstName && (
                      <FormFeedback>
                        {' '}
                        {errors.firstName.message? errors.firstName.message: 'El nombre es obligatorio'}{' '}
                      </FormFeedback>
                    )}
                  </Col>
                  <Col md="4" className="mb-1">
                    <Label className="form-label" for="lastName">
                      Apellidos
                    </Label>
                    <Controller
                      id="lastName"
                      name="lastName"
                      control={control}
                      render={({ field }) => (
                        <Input
                          placeholder="Doe"
                          invalid={errors.lastName && true}
                          {...field}
                          readOnly
                        />
                      )}
                    />
                    {errors.lastName && (
                      <FormFeedback>
                        {' '}
                        {errors.lastName.message? errors.lastName.message: 'El apellido es obligatorio'}
                      </FormFeedback>
                    )}
                  </Col>
                  <Col md="4" className="mb-2">
                    <Label className="form-label" for="documentType">
                      Tipo de documento*
                    </Label>
                    <Controller
                      id="documentType"
                      name="documentType"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isClearable={false}
                          isDisabled
                          classNamePrefix="select"
                          options={documentTypes}
                          theme={selectThemeColors}
                          className={classnames('react-select', {
                            'is-invalid': errors.documentType
                          })}
                        />
                      )}
                    />
                    {errors.documentType && (
                      <FormFeedback>
                        Por favor seleccione un tipo de documento valido
                      </FormFeedback>
                    )}
                  </Col>
                  <Col md="6" className="mb-1">
                    <Label className="form-label" for="documentNumber">
                      Numero de documento*
                    </Label>
                    <div
                      style={{
                        display: isDuiValidation ? 'none' : 'block'
                      }}
                    >
                      <Controller
                        id="documentNumber"
                        name="documentNumber"
                        control={control}
                        render={({ field }) => {
                          return (
                            <Cleave
                              options={{
                                delimiter: '',
                                blocks: [12],
                                uppercase: true
                              }}
                              placeholder={'Numero de documento'}
                              className={classnames('form-control', {
                                'is-invalid':
                                  data !== null &&
                                  (data.documentNumber === null ||
                                    !data.documentNumber?.length ||
                                    errors.documentNumber)
                              })}
                              readOnly
                              {...field}
                            />
                          )
                        }}
                      />
                      {errors.documentNumber && (
                        <FormFeedback>
                          {errors.documentNumber.message ? (
                            <strong>{errors.documentNumber.message}</strong>
                          ) : (
                            'El numero de documento es obligatorio'
                          )}
                        </FormFeedback>
                      )}
                    </div>
                    <div
                      style={{
                        display: isDuiValidation ? 'block' : 'none'
                      }}
                    >
                      <Controller
                        id="documentNumber"
                        name="documentNumber"
                        control={control}
                        render={({ field }) => {
                          return (
                            <Cleave
                              options={{
                                delimiter: '-',
                                blocks: [8, 1],
                                uppercase: true
                              }}
                              placeholder={'Numero DUI'}
                              className={classnames('form-control', {
                                'is-invalid':
                                  data !== null &&
                                  (data.documentNumber === null ||
                                    !data.documentNumber?.length ||
                                    errors.documentNumber)
                              })}
                              {...field}
                            />
                          )
                        }}
                      />
                      {errors.documentNumber && (
                        <FormFeedback>
                          {errors.documentNumber.message ? (
                            <strong>{errors.documentNumber.message}</strong>
                          ) : (
                            'El numero de documento es obligatorio'
                          )}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>

                  <Col md="6" className="mb-1">
                    <Label className="form-label" for="phoneNumber">
                      Celular
                    </Label>
                    <InputGroup className="input-group-merge">
                      <Controller
                        id="phoneNumber"
                        name="phoneNumber"
                        control={control}
                        render={({ field }) => {
                          const options = { blocks: [12], uppercase: true }
                          return (
                            <Cleave
                              id="phoneNumber"
                              name="phoneNumber"
                              placeholder="503 7080 5520"
                              options={options}
                              className={classnames('form-control', {
                                'is-invalid':
                                  data !== null &&
                                  (data.phoneNumber === null ||
                                    !data.phoneNumber?.length ||
                                    errors.phoneNumber)
                              })}
                              {...field}
                              readOnly
                            />
                          )
                          /*<Input placeholder='+503 70805520' type='number'
                                                   invalid={errors.phoneNumber && true} {...field} />*/
                        }}
                      />
                      {errors.phoneNumber && (
                        <FormFeedback>
                          {errors.phoneNumber.message ? (
                            <strong>{errors.phoneNumber.message} </strong>
                          ) : (
                            'El numero teléfono es obligatorio'
                          )}
                        </FormFeedback>
                      )}
                    </InputGroup>
                  </Col>
                  <Col md="6" className="mb-1" style={{display: "none"}}>
                    <Label className="form-label" for="email">
                      Email
                    </Label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <Input
                          type="email"
                          id="email"
                          placeholder="john.doe@example.com"
                          invalid={errors.email && true}
                          {...field}
                        />
                      )}
                    />
                    {errors.email && (
                      <FormFeedback>
                        {errors.email.message ? (
                          <strong>{errors.email.message}</strong>
                        ) : (
                          'El email es obligatorio'
                        )}
                      </FormFeedback>
                    )}
                  </Col>
                  <Col md="6" className="mb-1" style={{display: "none"}}>
                    <Label className="form-label" for="birthdate">
                      Fecha de nacimiento
                    </Label>
                    <Controller
                        id="birthdate"
                        name="birthdate"
                        control={control}
                        render={({ field }) => (
                            <CustomDate
                                {...field}
                                error={errors?.birthdate?.message}
                                disableDay={false}
                            />
                        )}
                    />
                    {errors.birthdate && (
                        <FormFeedback>
                          {errors.birthdate.message ? (
                              <strong>{errors.birthdate.message}</strong>
                          ) : (
                              'La fecha de nacimiento es obligatoria'
                          )}</FormFeedback>
                    )}
                  </Col>

                </Row>
              </Fragment>
            )}

            {!loading && verified && (
              <div className="row">
                <div className="col-12 px-2 text-center">
                  <Alert color="success">
                    <div className="alert-body py-3">
                      <CheckCircle size={32} />
                      <h3 className="text-success pt-2">
                        Información verificada!
                      </h3>
                    </div>
                  </Alert>
                </div>
              </div>
            )}
            <hr />

            <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={isValidData}
                onChange={() => setIsValidData(!isValidData)}
              />
              Confirmo que la información es correcta
            </Label>
          </FormGroup>
          </CardBody>
          <CardFooter className="border-0">
            <div className="d-flex justify-content-between">
              {!verified && (
                <>
                  {' '}
                  <Button
                    color="primary"
                    className="btn-prev"
                    onClick={() => stepper.previous()}
                  >
                    <ArrowLeft
                      size={14}
                      className="align-middle me-sm-25 me-0"
                    ></ArrowLeft>
                    <span className="align-middle d-sm-inline-block d-none">
                      Anterior
                    </span>
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    className="btn-next"
                    disabled={loading || !!Object.keys(errors).length || !isValidData}
                  >
                    <span className="align-middle d-sm-inline-block d-none">
                      Finalizar
                    </span>
                    <ArrowRight
                      size={14}
                      className="align-middle ms-sm-25 ms-0"
                    ></ArrowRight>
                  </Button>
                </>
              )}
            </div>
          </CardFooter>
        </Card>
      </Form>
    </div>
  )
}

export default PersonalInfo
